export const providers = [
  {
    id: 1,
    name: 'Evolution Gaming',
    logo: 'https://public.readdy.ai/ai/img_res/d95cdd7870247a5d615d08a16e5b75f9.jpg',
    description: 'Мировой лидер в области live-игр с дилерами. Предлагает более 500 игр в HD и 4K качестве.',
    topGames: ['Lightning Roulette', 'Crazy Time', 'Monopoly Live', 'Dream Catcher', 'Mega Ball'],
    features: ['4K трансляция', 'Русскоязычные дилеры', 'VIP столы', 'Мобильная оптимизация'],
    background: 'https://readdy.ai/api/search-image?query=professional%20live%20casino%20studio%20with%20gaming%20tables%20elegant%20dealers%20modern%20lighting%20equipment%20broadcast%20quality%20dark%20luxurious%20atmosphere&width=800&height=500&seq=evolution-bg-001&orientation=landscape',
    founded: 2006,
    gamesCount: 500
  },
  {
    id: 2,
    name: 'Pragmatic Play Live',
    logo: 'https://readdy.ai/api/search-image?query=pragmatic%20play%20live%20logo%20modern%20casino%20provider%20emblem%20dark%20background%20professional%20brand%20identity%20sleek%20design&width=200&height=100&seq=pragmatic-logo-002&orientation=landscape',
    description: 'Инновационный провайдер с уникальными игровыми шоу и классическими столами.',
    topGames: ['Sweet Bonanza Candyland', 'Mega Wheel', 'Mega Sic Bo', 'Speed Baccarat', 'Blackjack Azure'],
    features: ['HD качество', 'Быстрые раунды', 'Бонусные игры', 'Многоязычная поддержка'],
    background: 'https://readdy.ai/api/search-image?query=modern%20casino%20live%20studio%20colorful%20game%20show%20set%20professional%20dealers%20bright%20lighting%20entertainment%20atmosphere%20premium%20quality&width=800&height=500&seq=pragmatic-bg-002&orientation=landscape',
    founded: 2015,
    gamesCount: 150
  },
  {
    id: 3,
    name: 'Ezugi',
    logo: 'https://readdy.ai/api/search-image?query=ezugi%20logo%20live%20casino%20provider%20emblem%20dark%20background%20professional%20brand%20identity%20modern%20elegant%20design&width=200&height=100&seq=ezugi-logo-003&orientation=landscape',
    description: 'Специализируется на аутентичных казино-играх с атмосферой настоящего игорного зала.',
    topGames: ['Ultimate Roulette', 'Unlimited Blackjack', 'Baccarat Knockout', 'Andar Bahar', 'Teen Patti'],
    features: ['Аутентичная атмосфера', 'Азиатские игры', 'Низкие лимиты', 'Круглосуточная работа'],
    background: 'https://readdy.ai/api/search-image?query=authentic%20casino%20floor%20live%20gaming%20tables%20professional%20croupiers%20elegant%20interior%20classic%20atmosphere%20luxury%20lighting%20premium%20quality&width=800&height=500&seq=ezugi-bg-003&orientation=landscape',
    founded: 2012,
    gamesCount: 120
  },
  {
    id: 4,
    name: 'Vivo Gaming',
    logo: 'https://readdy.ai/api/search-image?query=vivo%20gaming%20logo%20live%20dealer%20provider%20emblem%20dark%20background%20modern%20brand%20identity%20professional%20design&width=200&height=100&seq=vivo-logo-004&orientation=landscape',
    description: 'Провайдер с фокусом на мобильные устройства и быстрые игры.',
    topGames: ['Auto Roulette', 'Speed Blackjack', 'Dragon Tiger', 'Sic Bo', 'Baccarat Squeeze'],
    features: ['Мобильная оптимизация', 'Быстрые игры', 'Низкая задержка', 'Компактный интерфейс'],
    background: 'https://readdy.ai/api/search-image?query=sleek%20modern%20casino%20studio%20minimalist%20design%20live%20gaming%20tables%20mobile%20optimized%20setup%20professional%20dealers%20contemporary%20atmosphere&width=800&height=500&seq=vivo-bg-004&orientation=landscape',
    founded: 2010,
    gamesCount: 80
  }
];